import { Chip } from '@shared/components';
import { formatNumber } from '@shared/utils';

export interface LOSQuestionCountChipProps {
  count: number;
}

export default function LOSQuestionCountChip(props: Readonly<LOSQuestionCountChipProps>) {
  const { count } = props;

  return (
    <Chip
      size='small'
      variant='filled'
      label={`Q: ${formatNumber(count)}`}
      sx={(theme) => ({
        background: theme.palette.grey[200],
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2),
        marginX: theme.spacing(2),
        minWidth: '54px',
      })}
    />
  );
}
